<template>
    <transition name="documents-sidebar">
        <div class="documents-sidebar" v-if="sidebarOpen">
            <div class="documents-sidebar-inner h-100 d-flex flex-column">
                <div class="documents-sidebar-title d-flex">
                    <h3 class="text-center flex-grow-1">Documents Basket</h3>
                    <i class="fas fa-times" @click="$store.commit('openSidebar', false)"></i>
                </div>
                <div class="documents-sidebar-documents flex-grow-1">
                    <transition class="documents-sidebar-document" :key="file.id" v-for="file in selectedFiles">
                        <div class="documents-sidebar-document">
                            <div class="d-flex">
                                <div class="flex-grow-0 documents-sidebar-document-image">
                                    <img src="/images/file-icon.svg">
                                    <span class="documents-sidebar-document-image-type">{{file.name.split('.').pop()}}</span>
                                </div>
                                <div class="flex-grow-1 documents-sidebar-document-content">
                                    {{file.name}}
                                </div>
                                <div class="flex-grow-0 pr-2">
                                    <i class="fas fa-times text-white" @click="$store.dispatch('selectFile', file)"></i>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>

                <div class="documents-sidebar-options mb-3 d-flex justify-content-center">
                    <modal title="Send via Email" button_content="Send via Email" button_class="btn btn-sm btn-secondary mr-1" v-can="buildPermission('download files')">
                        <send-via-email></send-via-email>
                    </modal>
                    <a class="btn btn-secondary btn-sm" download="download" :href="'/api/documents/file/download/zip?files[]=' + Object.keys(selectedFiles).join('&files[]=')" v-can="buildPermission('download files')">Download Zip</a>
                </div>

                <div class="documents-sidebar-footer" v-can="buildPermission('copy files')">
                    <h3 class="text-center pb-2 text-white">Clipboard</h3>

                    <div class="documents-sidebar-document" v-for="document in clipboard">
                        <div class="d-flex">
                            <div class="flex-grow-0 documents-sidebar-document-image">
                                <img src="/images/file-icon.svg">
                            </div>
                            <div class="flex-grow-1 documents-sidebar-document-content">
                                {{document.name}}
                            </div>
                            <div class="flex-grow-0 pr-2">
                                <i class="fas fa-times text-white" @click="$store.dispatch('selectFileForCopy', document)"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import SendViaEmail from "./Forms/SendViaEmail";
    import { mapState, mapGetters } from "vuex";

    export default {
        name: "Sidebar",
        components: {SendViaEmail},

        computed: {
            ...mapGetters({
                buildPermission: 'buildPermission'
            }),

            ...mapState({
                selectedFiles: 'selectedFiles',
                clipboard: 'clipboard',
                sidebarOpen: 'sidebarOpen'
            })
        }
    }
</script>
